import CheckInTerminal from "./CheckInTerminal";

export function CheckinPage() {
  return <CheckInTerminal />;
}

